import script from "./CreateBookForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateBookForm.vue?vue&type=script&setup=true&lang=ts"

import "./CreateBookForm.vue?vue&type=style&index=0&id=da7b5984&lang=css"

const __exports__ = script;

export default __exports__